import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink, Link } from 'react-router-dom';

import * as actions from '../../actions';
import { formatProgress } from '../../util/formatProgress';
import { cleanString } from '../../util/renderHelper';
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';

const SubSectionProvider = ({
  isMobile,
  name,
  slug,
  pathName,
  url,
  openCurrentProcessInfo
}) =>
  isMobile ? (
    <span className="nav-item__name">{cleanString(name)}</span>
  ) : (
    <li className="nav-item">
      <NavLink
        data-url={url}
        className="nav-link"
        to={`${pathName}/${slug}`}
        onClick={() => openCurrentProcessInfo()}
      >
        {cleanString(name)}
      </NavLink>
    </li>
  );

const SectionProvider = ({
  section,
  index,
  isCurrent,
  isMobile,
  pathName,
  openCurrentProcessInfo
}) => {
  const displaySubSections = section.subSections.map(subSection => (
    <SubSectionProvider
      {...subSection}
      isMobile={isMobile}
      key={`sub-section-${subSection.id}`}
      pathName={`${pathName}/${section.slug}`}
      sectionId={section.id}
      openCurrentProcessInfo={openCurrentProcessInfo}
    />
  ));

  if (isMobile) {
    return (
      <Link
        to={`${pathName}/${section.slug}`}
        className="nav-section nav-section--mobile"
      >
        <div className="nav-section__wrapper">
          <span className="nav-section__name">{cleanString(section.name)}</span>
        </div>
        <div className="nav-section__icon">
          <IconChevronRight />
        </div>
      </Link>
    );
  }

  return (
    <div className={`nav-section${isCurrent ? ' nav-section--current' : ''}`}>
      <div className="nav-section__wrapper">
        <NavLink
          className="nav-section__name"
          to={`${pathName}/${section.slug}`}
        >
          {cleanString(section.name)}
        </NavLink>
        {section.subSections.length ? (
          <ul className="nav-list">{displaySubSections}</ul>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

const SectionsProvider = ({
  currentId,
  isMobile,
  onClickMobileHandler,
  pathName,
  sections,
  openCurrentProcessInfo
}) => {
  const displaySections = sections.map((section, index) => (
    <SectionProvider
      section={section}
      index={index + 1}
      isCurrent={section.id === currentId}
      isMobile={isMobile}
      key={`section-${section.id}`}
      onClickMobileHandler={onClickMobileHandler}
      pathName={pathName}
      openCurrentProcessInfo={openCurrentProcessInfo}
    />
  ));
  return <div className="nav-sections">{displaySections}</div>;
};

class ProviderNavigation extends Component {
  static displayName = 'ProviderNavigation';

  componentDidMount() {
    const { updateProgress } = this.props;
    const componentProgress = formatProgress(this.constructor.displayName, true);
    updateProgress(componentProgress);
    this.addDefaultCurrent();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      match: {
        params: { providerSection }
      },
      isMobile
    } = this.props;

    if (prevProps.match.params.providerSection !== providerSection) {
      this.checkCurrent();
    }

    if (prevProps.isMobile !== isMobile && !isMobile) {
      this.addDefaultCurrent();
    }
  }

  addDefaultCurrent() {
    const {
      sections,
      match: {
        params: { providerSection }
      },
      isMobile
    } = this.props;
    if (sections.length > 0 && !providerSection) {
      !isMobile && this.defaultCurrent();
    } else {
      this.checkCurrent();
    }
  }

  defaultCurrent() {
    const {
      sections,
      history,
      match: { url }
    } = this.props;

    const defaultContent = sections.find(section => section !== undefined);
    const path = url.substr(-1) !== '/' ? `${url}/` : `${url}`;
    history.replace(`${path}${defaultContent.slug}`);
  }

  checkCurrent() {
    const {
      currentId,
      sections,
      updateCurrentContent,
      match: {
        params: { providerSection }
      },
      isMobile,
      errorFindCurrentSection
    } = this.props;
    const findCurrentSection = sections.find((section, index) => {
      if (section.slug === providerSection) {
        section.isOpen = true;
        section.index = index + 1;
        return true;
      } else {
        return false;
      }
    });

    if (typeof findCurrentSection === 'undefined') {
      return errorFindCurrentSection();
    }

    if (currentId === findCurrentSection.id && !isMobile) {
      return;
    }

    updateCurrentContent(findCurrentSection);
  }

  render() {
    const {
      sections,
      match,
      currentId,
      isMobile,
      openCurrentProcessInfo
    } = this.props;
    const pathName =
      match.url.indexOf(`/${match.params.providerSection}`) !== -1
        ? match.url.slice(
            0,
            match.url.indexOf(`/${match.params.providerSection}`)
          )
        : match.url.substr(-1) !== '/'
        ? match.url
        : match.url.slice(0, -1);
    return sections ? (
      <div className="provider-dashboard__nav">
        <SectionsProvider
          currentId={currentId}
          isMobile={isMobile}
          pathName={pathName}
          sections={sections}
          onClickMobileHandler={this.onClickMobileHandler}
          openCurrentProcessInfo={openCurrentProcessInfo}
        />
      </div>
    ) : (
      ''
    );
  }
}

const mapStateToProps = state => ({
  currentId: state.currentProviderContent.id,
  isMobile: state.app.isMobile,
  progress: state.app.progress,
  sections: state.providerDetails.data.sections
});

const mapDispatchToProps = dispatch => ({
  errorFindCurrentSection: () => dispatch(actions.fetchActions.getError()),
  openCurrentContent: () =>
    dispatch(actions.currentProviderActions.openCurrentContent()),
  openCurrentProcessInfo: () =>
    dispatch(actions.currentProviderActions.openCurrentProcessInfo()),
  updateCurrentContent: content =>
    dispatch(actions.currentProviderActions.updateCurrentContent(content)),
  updateProgress: progress =>
    dispatch(actions.appActions.updateProgress(progress)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProviderNavigation));
